import {
  Injectable,
  Component,
  OnInit,
  ViewChild,
  Inject
} from '@angular/core';
import { forkJoin } from 'rxjs';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { DriveRepresentation } from '../dtos/DriveRepresentation';
import { IcsDriveService } from '../ics-drive.service';

@Component({
  selector: 'lib-app-upload-modal',
  template: `<div class="dailog__container">
  <button class="closeDailog" mat-button [mat-dialog-close]="true">
    <img src="{{ imgBaseUrl }}close.svg" class="img--close_icon" alt="">
  </button>
  <mat-tab-group>
    <mat-tab label="Upload">
      <div class="dailog__container--computer">
        <div class="container">
          <div class="row">
            <div class="col-md-12 col-sm-12 col-xs-12">
              <div class="uploadContainer row">
                <h3 class=" col-md-12 uploadContainer--heading text-center text__uppercase">
                  Upload Your File
                </h3>
              </div>
              <div class="row">
                <div (drop)="drop($event)" (dragover)="allowDrop($event)" class="uploadContainer__drangDrop col-md-6 offset-md-3">
                  <img src="{{ imgBaseUrl }}dragdrop_icon.svg" class="img--dragdrop_icon" alt="">
                  <p class="uploadContainer__drangDrop--label text-center">
                    Drag your files here
                  </p>
                  <p class="uploadContainer__drangDrop--label text-center">
                    Or
                  </p>

                  <input *ngIf="showMultiple" style="display:none" type="file" (change)="onFilesAdded()" multiple #file>
                  <input *ngIf="showMultiple===false" style="display:none" type="file" (change)="onFilesAdded()" #file>
                  <button type="button" [disabled]="uploading || uploadSuccessful" name="button" class="uploadButton" (click)="addFiles()">
                    browse files from your computer

                  </button>

                </div>
              </div>

              <div class="row">
                <div class="uploadContainer__uploadFileList col-md-6 offset-md-3">

                  <mat-dialog-content>
                    <mat-list>
                      <mat-list-item *ngFor="let file of files">
                        <h4 mat-line class="file__name">{{file.name}}</h4>
                        <mat-progress-bar *ngIf="progress" mode="determinate" [value]="progress['filename'].progress | async"></mat-progress-bar>
                      </mat-list-item>
                    </mat-list>
                  </mat-dialog-content>

                  <mat-dialog-actions class="actions">
                    <button *ngIf="showCancelButton" class="uploadButton" mat-button mat-dialog-close>Cancel</button>

                    <button mat-raised-button color="primary" class="uploadButton" [disabled]="!canBeClosed" (click)="closeDialog()">{{primaryButtonText}}</button>
                  </mat-dialog-actions>

                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </mat-tab>
    <mat-tab label="Drive">
      <div class="dailog__container--computer">
        <div class="container">
          <div class="row">
            <div class="col-md-12 col-sm-12 col-xs-12">
              <div class="uploadContainer">
                <div *ngIf="!driveHideButton">
                  <img src="{{ imgBaseUrl }}leapdrive_logo.svg" class="img--dragdrop_icon leapdriveIcon" alt="">
                  <h3 class="uploadContainer--heading heading__label text-center text__uppercase">
                    Leap Drive
                  </h3>

                  <p class="uploadContainer__drangDrop--label text-center">
                    Choose files from leap drive
                  </p>


                  <mat-dialog-actions class="actions">
                    <!-- (click)="viewDirectoryList('38') -->
                    <button class="uploadButton" mat-button (click)="connectDrive()">Connect Drive </button>
                  </mat-dialog-actions>
                </div>
                <div *ngIf="loader" class="loader">
                  <img src="https://s3-us-west-2.amazonaws.com/repository-leadics-test/leap/leap_icons/loader_leap.gif" alt="">
                  <p class="text-muted">loading</p>
                </div>
                <div *ngIf="showData">

                  <section class="container__drive">
                    <div class="container__drive--Cont">
                      <p class="heading">
                        Files
                      </p>
                      <div class="row files__container">
                        <div *ngFor="let obj of driveData;" class="card__property__cont" (click)="onSelect(obj)">
                          <div class="card__property__cont--file " title="{{obj.name}}">
                            <img class=" card__property__cont--file--icon " src="{{imgBaseUrl}}{{getFileExt(obj.name)}}">
                          </div>
                          <div class="card__property__cont--file--name">
                            <p class=" card__property__cont--file--name--label ellipsis--xs" title="{{obj.name}}">
                              {{obj.name}}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </section>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>`,
  styles: [`.files__container{margin:0;max-height:58vh;overflow-y:auto}.text__uppercase{text-transform:uppercase;font-family:Raleway,sans-serif!important}.dailog__container{position:relative}.dailog__container .mat-button-focus-overlay{background:rgba(0,0,0,0)!important}.dailog__container mat-tab-body{background:#fff!important;box-shadow:0 0!important}.dailog__container .uploadContainer .file__name{font-family:Raleway,sans-serif!important;font-weight:400;font-size:14px}.dailog__container .uploadContainer__uploadFileList mat-list.mat-list{max-height:23vh!important;overflow-y:auto}.dailog__container .uploadContainer__uploadFileList .file__name.mat-line{font-family:Raleway,sans-serif!important;font-weight:400;font-size:14px}.dailog__container .uploadContainer__uploadFileList .mat-list .mat-list-item{display:block;height:23px!important}.dailog__container .uploadContainer__uploadFileList .mat-dialog-actions{padding:12px 0;margin-bottom:0!important}.dailog__container .uploadContainer__drangDrop{padding:20px;margin:10px;background:#fff;line-height:1.3em;border:2px dashed #c2b7c8;border-radius:10px;box-shadow:0 0 0 4px #fff,2px 1px 6px 4px #fff;text-shadow:-1px -1px #fff;font-weight:400}.dailog__container .uploadContainer__drangDrop--label{color:rgba(58,19,77,.5);font-size:14px;font-family:Raleway,sans-serif!important;margin-bottom:6px;font-weight:600}.dailog__container .uploadContainer--heading{color:#3a134d;font-size:16px;font-weight:600;margin-bottom:0}.dailog__container .uploadContainer--heading.heading__label{color:#169696!important;margin:0;padding:0!important;font-size:20px}.dailog__container .uploadButton{background:#65ceee;color:#fff;font-family:Raleway,sans-serif;font-weight:600;border:none;border-radius:4px;margin:0 auto;display:block;padding:5px 13px}.dailog__container .closeDailog{position:absolute;top:5px;right:5px;background:0 0;border:0;z-index:9999;cursor:pointer}.dailog__container .img--dragdrop_icon{width:50px;height:50px;margin:0 auto 15px;display:block}.dailog__container .img--dragdrop_icon.leapdriveIcon{height:auto!important;width:227px!important;margin-top:50px}.dailog__container .img--close_icon{width:10px;height:10px}.dailog__container .container__drive--Cont .heading{color:#440050;font-size:1em;font-weight:700;margin-top:15px;margin-bottom:5px}.dailog__container .container__drive--Cont .row{margin:0}.dailog__container .container__drive--Cont .row .card__property__cont{margin:7.5px;padding:15px 0 0;background:#eaf0f4;border-radius:3px;display:inline-block}.dailog__container .container__drive--Cont .row .card__property__cont--file--name{background:#fff;border-radius:0 0 3px 3px;border:1px solid rgba(58,19,77,.2);border-top:0!important}.dailog__container .container__drive--Cont .row .card__property__cont--file--name--label{font-size:11px;margin:0 10px;padding:8px 0}.dailog__container .container__drive--Cont .row .card__property__cont--file--icon{width:50px;margin:0 auto;display:block;height:70px}.deactive--color--label{color:#8a8a8a!important;cursor:pointer}@media (min-width:768px){.offset-md-3{margin-left:25%!important}}@media (max-width:1025px){.hidden-sm,.hidden-xs{display:none}.col-sm-xs-full{width:100%!important;max-width:100%!important;flex:0 0 100%!important}}.loader{margin-top:22%}.loader img{width:60px}`],
  providers: [IcsDriveService]
})
@Injectable()
export class UploadModalComponent implements OnInit {
  selectedFile: File;
  public responseData: Array<DriveRepresentation>;
  public driveData: any = [];
  public showData: boolean;
  driveRepresentation: DriveRepresentation;
  @ViewChild('file')
  file;
  public files: Set<File> = new Set();
  buttonDisabled = false;
  progress;
  canBeClosed = false;
  primaryButtonText = 'Upload';
  showCancelButton = true;
  uploading = false;
  uploadSuccessful = false;
  resultData = '';
  showFinish = false;
  showMultiple = false;
  showCloseButton = false;
  loader = false;
  driveHideButton = false;
  imgBaseUrl =
    'https://s3-us-west-2.amazonaws.com/repository-leadics-test/leap/leap_icons/uploadRepo/';
  constructor(
    public dialogRef: MatDialogRef<UploadModalComponent>,
    public uploadService: IcsDriveService,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {}

  ngOnInit() {
    this.showData = false;
    this.showMultiple = this.data.dataKey;
  }
  addFiles() {
    this.file.nativeElement.click();
  }

  onFilesAdded() {
    const files: { [key: string]: File } = this.file.nativeElement.files;
    for (let key in files) {
      if (!isNaN(parseInt(key, 10))) {
        this.files.add(files[key]);
      }
    }
    this.canBeClosed = true;
  }

  closeDialog() {
    if (this.uploadSuccessful) {
      return this.dialogRef.close(this.responseData['resp']);
    } else {
      this.progress = this.uploadService.upload(this.files);
      let newResult: any;
      newResult = this.progress;
      this.uploadSuccessful = true;
    }
    this.responseData = this.progress;

    let allProgressObservables = [];
    for (let key in this.progress) {
      allProgressObservables.push(this.progress[key].progress);
    }
    this.dialogRef.disableClose = true;
    this.showCancelButton = false;

    this.primaryButtonText = 'Finish';
    this.canBeClosed = false;

    forkJoin(allProgressObservables).subscribe(end => {
      this.canBeClosed = true;
      this.dialogRef.disableClose = false;
      this.uploadSuccessful = true;
      this.uploading = false;
      this.showCloseButton = true;
    });
  }

  onSelect(value) {
    let status: any = [];
    let arrayResp = new Array();
    const resultData: any = value;
    this.driveRepresentation = new DriveRepresentation();
    this.driveRepresentation.id = resultData.id;
    this.driveRepresentation.name = resultData.name;
    arrayResp.push(this.driveRepresentation);
    status['resp'] = arrayResp;
    this.responseData = status;
    this.uploadSuccessful = true;
    this.closeDialog();
  }

  connectDrive() {
    this.loader = true;
    this.driveHideButton = true;

    this.uploadService.getDrive().subscribe(
      response => {
        this.driveData = response[0]['files'];
        this.loader = false;
        this.showData = true;
      },
      error => {}
    );
  }

  getFileExt(args) {
    let file = '';
    const lastCHar = args.substr(-4);
    if (lastCHar === '.png' || lastCHar === '.jpg' || lastCHar === 'jepg') {
      file = 'image_icon.svg';
    } else {
      file = 'file_icon.svg';
    }
    return file;
  }

  drop(ev) {
    ev.preventDefault();
    let files = ev.dataTransfer.files;
    if (files.length > 0) {
      for (let key in files) {
        if (!isNaN(parseInt(key, 10))) {
          this.files.add(files[key]);
        }
      }
    }
  }

  allowDrop(ev) {
    ev.preventDefault();
  }
}
